import { Box, CircularProgress, Typography } from '@mui/material';
import { useFormatting } from '@/utils/formatting';
import styled from '@emotion/styled';
import { useCompanyBalance } from '@/services/paymentsQuery';

const BalanceList = styled('div')`
    display: flex;
    justify-content: space-between;
`;

export const CompanyBalance = () => {
    const { data: currentCompanyBalance, isPending } = useCompanyBalance();
    const { getBalanceLabel } = useFormatting();

    return (
        <>
            {currentCompanyBalance?.data &&
                currentCompanyBalance?.data?.paymentSource ===
                    'InstaPaidAccount' && (
                    <>
                        <Box
                            sx={{
                                float: 'right',
                                textAlign: 'right',
                                fontSize: '1.1rem'
                            }}
                            boxShadow={'0px 0px 5px -2px gray'}
                            borderRadius={'12px'}
                            padding={'20px'}
                            marginLeft={'auto'}
                        >
                            <BalanceList>
                                <Typography textAlign={'left'}>
                                    Current balance:{' '}
                                </Typography>
                                <Typography
                                    textAlign={'right'}
                                    marginLeft={'50px'}
                                >
                                    {getBalanceLabel(
                                        currentCompanyBalance?.data
                                            ?.currentBalance,
                                        currentCompanyBalance?.data?.currency,
                                        undefined,
                                        true
                                    )}
                                </Typography>
                            </BalanceList>
                            <BalanceList>
                                <Typography textAlign={'left'}>
                                    Pending approval:{' '}
                                </Typography>
                                <Typography
                                    textAlign={'right'}
                                    marginLeft={'50px'}
                                >
                                    {getBalanceLabel(
                                        currentCompanyBalance?.data
                                            ?.awaitingAdminApprovalTotal,
                                        currentCompanyBalance?.data?.currency,
                                        undefined,
                                        true
                                    )}
                                </Typography>
                            </BalanceList>
                            <BalanceList>
                                <Typography
                                    fontWeight={'bold'}
                                    textAlign={'left'}
                                >
                                    Available balance:{' '}
                                </Typography>
                                <Typography
                                    fontWeight={'bold'}
                                    textAlign={'right'}
                                    marginLeft={'50px'}
                                >
                                    {getBalanceLabel(
                                        currentCompanyBalance?.data
                                            ?.availableBalance,
                                        currentCompanyBalance?.data?.currency,
                                        undefined,
                                        true
                                    )}
                                </Typography>
                            </BalanceList>
                        </Box>
                        <Box sx={{ clear: 'both' }}></Box>
                    </>
                )}
            {isPending && (
                <Box mt={2} mr={10}>
                    <CircularProgress size={20} />
                </Box>
            )}
        </>
    );
};
